export default __webpack_public_path__ + "static/media/svg-1.22c540bd.svg";